module.exports = __webpack_public_path__ + "static/img/android.ecf062a.png";